import React, { Component, Suspense, useState } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { withRouter } from "react-router-dom";
import AppContext from "app/appContext";
import {
  setLayoutSettings,
  setDefaultSettings,
} from "app/redux/actions/LayoutActions";

import ChatbotIa from "@gull/components/ChatbotIa/ChatbotIa";
import { GullLayouts } from ".";

class GullLayout extends Component {
  state = {};

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
    }
  }
  componentDidMount() {
    this.initAppDirection();
  }

  initAppDirection = () => {
    let { settings } = this.props;
    setTimeout(() => {
      document.documentElement.setAttribute("dir", settings.dir);
    });
  };

  render() {
    const domain = this.props.location.pathname.split('/');
    let { activeLayout, route, settings } = this.props;
    let Layout = GullLayouts[activeLayout];
    
    return (
        <Suspense>
        <React.Fragment>
          <Layout routes={route.routes}></Layout>
          {/* Assistant IA : monté ici pour conserver l'historique pendant la navigation */}
          <ChatbotIa />
        </React.Fragment>
      </Suspense>
    );
  }
}

const mapStateToProps = (state) => ({
  setLayoutSettings: PropTypes.func.isRequired,
  setDefaultSettings: PropTypes.func.isRequired,
  settings: state.layout.settings,
  activeLayout: state.layout.settings.activeLayout,
  defaultSettings: state.layout.defaultSettings,
});

GullLayout.contextType = AppContext;

export default withRouter(
  connect(mapStateToProps, { setLayoutSettings, setDefaultSettings })(
    GullLayout
  )
);
